<template>
    <el-form :inline="true" :model="queryParam" class="mainSearch">
      <el-form-item label="标题">
        <el-input v-model="queryParam.title" placeholder="输入标题" />
      </el-form-item>
      <el-form-item label="审核状态">
        <el-select v-model="queryParam.checkstatus" placeholder="审核状态" style="width:120px">
          <el-option label="正常" :value="1" />
          <el-option label="停用" :value="2" />
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="queryParam.status" placeholder="活动状态" style="width:120px">
          <el-option label="正常" :value="1" />
          <el-option label="停用" :value="2" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getListActivity">查询</el-button>
        <el-button @click="resetSearch">重置</el-button>
      </el-form-item>
    </el-form>
    <el-row>
      <el-col :span="24">
        <div class="mainTableTop">
          <el-button
            type="primary"
            @click="(dialog = true), doActivityAdd()"
            v-hasPermission="['activity:add']"
            >发布活动</el-button>
        </div>
      </el-col>
    </el-row>
  
    <el-row class="mainTableBox">
      <el-col :span="24" class="mpadding">
        <el-table ref="tableRef" v-loading="loadingData" :data="tableData" class="mainTable">
          <el-table-column prop="activityUsers[0].username" label="发布人"/>
          <el-table-column prop="title" label="标题"/>
          <el-table-column prop="coverUrl" label="封面">
            <template #default="scope">
              <el-image :src="scope.row.coverUrl" style="width:50px;" />
            </template>
          </el-table-column>
          <el-table-column prop="started" label="活动时间">
            <template #default="scope">
              <span
                v-text="
                  util.formatDateUnix(scope.row.started, 'MM-dd hh:mm')+'至'+util.formatDateUnix(scope.row.ended, 'MM-dd hh:mm')
                "
              ></span>
            </template>
          </el-table-column>
          <el-table-column prop="applystarted" label="报名时间">
            <template #default="scope">
              <span
                v-text="
                  util.formatDateUnix(scope.row.applystarted, 'MM-dd hh:mm')+'至'+util.formatDateUnix(scope.row.applyended, 'MM-dd hh:mm')
                "
              ></span>
            </template>
          </el-table-column>
          <el-table-column prop="password" label="密码"/>
          <el-table-column prop="fee" label="活动费用"/>
          <el-table-column prop="usernum" label="成员数"/>
          <el-table-column prop="medianum" label="媒体数"/>
          <el-table-column prop="created" label="创建时间">
            <template #default="scope">
              <span
                v-text="
                  util.formatDateUnix(scope.row.created, 'yyyy-MM-dd hh:mm')
                "
              ></span>
            </template>
          </el-table-column>
          <el-table-column prop="checkstatus" label="审核状态" >
            <template #default="scope">
              <el-tag
                round
                :type="scope.row.checkstatus === 1 ? 'success' : 'danger'"
                disable-transitions
                ><span v-text="util.showCommonStatus(scope.row.checkstatus)"></span>
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" >
            <template #default="scope">
              <el-tag
                round
                :type="scope.row.status === 1 ? 'success' : 'danger'"
                disable-transitions
                ><span v-text="util.showCommonStatus(scope.row.status)"></span>
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right">
            <template #default="scope">
              <el-link
              type="primary"
              @click="(dialog = true), doActivityEdit(scope.$index, scope.row)"
              v-hasPermission="['activity:edit']"
              >编辑</el-link>
  
              <el-popconfirm
                confirm-button-type="primary"
                confirm-button-text="确定"
                cancel-button-text="取消"
                icon-color="#626AEF"
                title="您确定删除吗？"
                width="200px"
                @confirm="doActivityDelete(scope.$index, scope.row)"
              >
                <template #reference>
                  <el-link
                    type="danger"
                    v-hasPermission="['activity:delete']"
                    >删除</el-link
                  >
                </template>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  
    <el-row class="mainTableBottom">
      <el-col :span="8">
        <!-- <div>
          <el-button type="primary">发布活动</el-button>
        </div> -->
      </el-col>
      <el-col :span="16">
        <div style="float: right">
          <el-pagination
            :hide-on-single-page="false"
            v-model:page-size="queryParam.pageSize"
            :page-sizes="[10, 15, 20, 30]"
            :background="true"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            @size-change="changeChangeSize"
            @current-change="changePage"
          />
        </div>
      </el-col>
    </el-row>
  
    <el-drawer
      ref="drawerRef"
      v-model="dialog"
      :title="title"
      direction="rtl"
      :close-on-click-modal="false"
      size="60%"
      @close="doActivityClose()"
    >
      <div class="common-drawer__content">
        <el-form
          ref="activityFormRef"
          :model="activityForm"
          :rules="rules"
          label-width="120px"
        >
        <el-form-item label="标题" prop="title">
            <el-input
              v-model.trim="activityForm.title"
              placeholder="请输入标题"
            ></el-input>
          </el-form-item>
          <el-form-item label="封面图" prop="coverUrl">
            <el-upload
              class="upload-demo"
              action="/api/upload/common"
              :auto-upload="true"
              ref="fileUpload1"
              :headers="headerUpload"
              :on-success="doUploadSuccess"
              :before-upload="beforeUpload"
              accept="image/png, image/jpeg, image/jpg"
              name="picture"
            >
            <template #trigger>
              <el-button type="primary">选择图片</el-button>
            </template>
             
              <template #tip>
                <div class="el-upload__tip">
                  请上传Png、Jpeg、Jpg后缀名且小于1M的文件。
                </div>
              </template>
            </el-upload>
            <el-image v-if="activityForm.coverUrl" style="width: 120px;display: block;" :src="activityForm.coverUrl" />
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input
              v-model.trim="activityForm.password"
              placeholder="请输入密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="地址" prop="address">
            <el-input
              v-model.trim="activityForm.address"
              placeholder="请输入地址"
            ></el-input>
          </el-form-item>
          <el-form-item label="报名数" prop="applynum">
            <el-input
              v-model.trim="activityForm.applynum"
              placeholder="请输入报名数"
            ></el-input>
          </el-form-item>
          <el-form-item label="费用" prop="fee">
            <el-input
              v-model.trim="activityForm.fee"
              placeholder="请输入费用"
            ></el-input>
          </el-form-item>
          <el-form-item label="活动介绍" prop="content">
            <el-input
              type="textarea"
              v-model.trim="activityForm.content"
              placeholder="请输入活动介绍"
            ></el-input>
          </el-form-item>
          <el-form-item label="审核状态" prop="checkstatus">
            <el-radio-group v-model="activityForm.checkstatus">
              <el-radio :label="1">通过</el-radio>
              <el-radio :label="2">未通过</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-radio-group v-model="activityForm.status">
              <el-radio :label="1">启用</el-radio>
              <el-radio :label="2">停用</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <div class="common-drawer__footer">
          <el-button @click="doActivityClose()">关闭</el-button>
          <el-button type="primary" :loading="loading" @click="doActivitySave">{{
            loading ? "提交中 ..." : "提交"
          }}</el-button>
        </div>
      </div>
    </el-drawer>
  </template>
  
  <script setup>
  import { ref, onMounted } from "vue";
  // import { useRouter } from "vue-router";
  import { ElDrawer, ElTable, ElMessage } from "element-plus";
  import { listActivity, deleteActivity,saveActivity  } from "@/api/activity";
    
  import util from "@/util/tool.js";
  // import storage from "@/util/storage.js";
  
  import store from "@/store";
  
  let timer;
  
  const dialog = ref(false);
  const loading = ref(false);
  const loadingData = ref(true);

  
  // const router = useRouter();
  // let open = (routeName, row) => {
  //   storage.saveSessionObject("activityPath",queryParam.value)
  //   router.push({
  //     name: routeName,
  //     params: { id: row.activityid },
  //     query: { eflag:row.eflag, name: row.name },
  //   });
  // };
  
  const drawerRef = ref(ElDrawer);
  
  const tableData = ref();
  const total = ref(0);
  const pageSize = ref(15); //每页显示条数
  
  let activityFormRef = ref();
  let title = ref("发布活动");
  
  // const defaultSelectDepart = ref([])
  
  //onMounted方法
  onMounted(() => {
    getListActivity();
  });
  
  
  //搜索查询
  const queryParam = ref({
    pageNo: 1,
    pageSize: pageSize.value,
    checkstatus:"",
    status: "",
    title: "",
  });
  const resetSearch = () => {
    queryParam.value = {
      pageNo: 1,
      pageSize: pageSize.value,
      checkstatus: "",
      status: "",
      title: "",
    };
    getListActivity();
  };
  
  //活动表单项
  let activityForm = ref({
    activityid: null,
    checkstatus: "",
    title: "",
    coverUrl: "",
    password: "",
    fee: '',
    content: '',
    address: '',
    applynum: "",
    status: 1,
  });
  
  //发布活动
  const doActivityAdd = () => {
    title.value = "发布活动";
    // console.log('add',activityForm.value)
  
    // activityForm.value.content = ''
    // editorRef.value.valueHtml = '<p></p>'
    resetForm();
  };
  
  //编辑活动
  const doActivityEdit = (index, obj) => {
    title.value = "编辑活动";
  
    activityForm.value = {
      activityid: obj.activityid,
      checkstatus: obj.checkstatus,
      title: obj.title,
      coverUrl: obj.coverUrl,
      password: obj.password,
      fee: obj.fee,
      content: obj.content,
      address: obj.address,
      applynum: obj.applynum,
      status: obj.status,
    };
  
  };
  const resetForm = () => {
    activityForm.value = {
      activityid: null,
      checkstatus: "",
      title: "",
      coverUrl: "",
      password: "",
      fee: '',
      content: '',
      address: '',
      applynum: "",
      status:1,
    };
  };
  
  //关闭活动表单弹窗
  const doActivityClose = () => {
    loading.value = false;
    dialog.value = false;
    clearTimeout(timer);
    activityFormRef.value.resetFields()
  };
  
  //保存活动数据
  const doActivitySave = () => {
    activityFormRef.value.validate((valid) => {
      if (!valid) {
        //ElMessage("请先完善表单数据填写！");
        return;
      }
      saveActivity(activityForm.value).then((res) => {
        loading.value = true;
        timer = setTimeout(() => {
          // 动画关闭需要一定的时间
          setTimeout(() => {
            loading.value = false;
          }, 400);
          if (res.data.code === 1) {
            getListActivity();
            doActivityClose();
          } else {
            ElMessage.error(res.data.msg);
          }
        }, 1000);
      });
    });
  };
  
  //更新活动状态
  const doActivityDelete = (index, obj) => {
    // console.log('obj.activityid',obj.activityid.toString())
    deleteActivity(obj).then((res) => {
      // console.log(res);
      if (res.data.code === 1) {
        getListActivity();
      } else {
        ElMessage.error(res.data.msg);
      }
    });
  };
  
  //分页
  const changePage = (current) => {
    queryParam.value.pageNo = current;
    getListActivity();
  };
  const changeChangeSize = (size) => {
    pageSize.value = size;
    queryParam.value.pageSize = size;
    getListActivity();
  };
  
  //活动列表API
  const getListActivity = () => {
    listActivity(queryParam.value).then((res) => {
      tableData.value = res.data.extend.pages.list;
      total.value = res.data.extend.pages.total;
      queryParam.value.pageSize = pageSize.value;
      loadingData.value = false
    });
  };
  
  //活动表单验证规则
  const rules = ref({
    title: [
      {
        required: true,
        message: "请输入标题",
        trigger: "blur",
      },
      {
        min: 2,
        max: 200,
        message: "标题长度2到200",
        trigger: "blur",
      },
    ],
     coverUrl: [
      {
        required: true,
        message: "请上传活动图",
        trigger: "blur",
      },
    ],
  });
  
  
  const filefail = ref("");
  const resultMsg = ref();
  const fileUpload1 = ref();
  const doUploadSuccess = (response) => {  
    if (response.code === 0) {    
      ElMessage.error(response.msg)
    } else {
      resultMsg.value = response.msg
      filefail.value = response.url
      activityForm.value.coverUrl = response.url
      setTimeout(function(){
        fileUpload1.value.clearFiles()
      },1000)
    }
  };
  const beforeUpload = (rawFile) => {
    if (rawFile.type !== 'image/png' && rawFile.type !=='image/jpeg' && rawFile.type !=='image/jpg') {
      ElMessage.error('请上传PNG、JPEG、JPG格式图片!')
      return false
    } else if (rawFile.size / 1024 / 1024 > 1) {
      ElMessage.error('请上传小于1MB的文件!')
      return false
    }
    resultMsg.value = '正在上传处理中，请勿关闭或跳转页面！'
    return true
  }
  
  const headerUpload = ref({
    Authorization: store.state.user.token,
  })
  </script>
  